// extracted by mini-css-extract-plugin
export var animationContainer = "_or-0";
export var footer = "_or-1";
export var gray = "_or-2";
export var lineItem = "_or-3";
export var lineItemImage = "_or-4";
export var lineItemInfo = "_or-5";
export var lineItemText = "_or-6";
export var lineItems = "_or-7";
export var modalContent = "_or-8";
export var options = "_or-9";
export var orderName = "_or-a";
export var refundAmount = "_or-b";